import React from "react";
import client from '../../../data/app2-sinistre'
import Interventions from './Interventions'

export function getPertinenceColor(pertinence) {
  if (pertinence > 80) {
    return "pertinence-green"
  }
  if (pertinence > 60) {
    return "pertinence-orange"
  }
  return "pertinence-red"
}

function User({ data, idOffre }) {
  var pertinence = data.offres.find(ladata => ladata.id === idOffre).pertinence;

  const pertinenceColor = getPertinenceColor(pertinence);
  return (
    <div className="card horizontal">
      <div className="card-image">
      </div>

      <div className="card-stacked">
        <div className="card-content"><span
          className="badge"><h3><span className={pertinenceColor}>{pertinence}%</span></h3></span>
          <h5 className="client"> {data.client.nom} {data.client.prenom}</h5>
          <p><i className="material-icons context-icons">directions_car</i> <strong>Véhicule
            : </strong>{data.vehicule.modele} {data.vehicule.immat}</p>
          <p><strong>Age du véhicule : </strong>{data.vehicule.dateDeproduction}</p>
          <p><strong>Kilométrage : </strong>{data.vehicule.kilometrage} Kms</p>
          <p><strong>Contact : </strong>{data.client.contact}</p>
          <blockquote>{data.offres.find(ladata => ladata.id === idOffre).texte}</blockquote>
          <Interventions sinistralite={data.sinistralite}/>

        </div>

      </div>
    </div>
  )
}

const ListUser = ({ idOffre }) => {
  return (
    client.filter(client => client.offres.filter(ladata => ladata.id === idOffre).length === 1)
        .sort((a,b)=> b.offres.find(ladata => ladata.id === idOffre).pertinence - a.offres.find(ladata => ladata.id === idOffre).pertinence)
      .map((data, index) => <User key={index} data={data} idOffre={idOffre}/>)
  )
};

export default ListUser